import { Injectable } from '@angular/core';
import { BaseBackend } from '@shared/apis/servers/base-backend';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpRequest } from '@angular/common/http';
import { timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConcealedDamageBackendServer extends BaseBackend {

  getConcealedDamages(builder): Observable<any> {
    return this.get('/concealed-damage', { params: builder });
  }

  getChartConcealedDamages(builder): Observable<any> {
    return this.get('/concealed-damage/chart', { params: builder });
  }

  getConcealedDamage(ticketNo): Observable<any> {
    return this.get(`/concealed-damage/${ ticketNo }`);
  }

  getCheckSerial(serialNo): Observable<any> {
    return this.get(`/concealed-damage/check-serial/${ serialNo }`);
  }

  createConcealedDamage(data): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    const options = {
      headers,
      reportProgress: true,
    };

    // change post for progress bar
    const uploadReq = new HttpRequest('POST', `${ this.backend }/concealed-damage`, data, options);
    return this.http.request(uploadReq).pipe(timeout(500000));
  }

  updateConcealedDamage(ticketNo, data): Observable<any> {
    return this.patch(`/concealed-damage/${ ticketNo }`, data);
  }

  deleteConcealedDamage(ticketNo): Observable<any> {
    return this.delete(`/concealed-damage/${ ticketNo }`);
  }

  updateComment(ticketNo, data): Observable<any> {
    return this.patch(`/concealed-damage/${ ticketNo }/comment`, data);
  }

  deleteFile(ticketNo, data): Observable<any> {
    const { fileTarget, fieldname, key } = data;
    return this.delete(`/concealed-damage/${ ticketNo }/file?fileTarget=${ fileTarget }&fieldname=${ fieldname }&key=${ key }`);
  }

  fileUpload(ticketNo, targetType, formData): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    const options = {
      headers,
      reportProgress: true,
    };

    const uploadReq = new HttpRequest('PATCH', `${ this.backend }/concealed-damage/${ ticketNo }/${ targetType }/file`, formData, options);
    return this.http.request(uploadReq).pipe(timeout(500000));
  }

  fileDownload(ticketNo, targetType): Observable<any> {
    return this.get(`/concealed-damage/${ ticketNo }/files/download?targetType=${ targetType }`);
  }

  syncRaRequestStatus(): Observable<any> {
    const uploadReq = new HttpRequest('POST', `${ this.backend }/batch/ConcealedDamageStatusUpdate`, '');
    return this.http.request(uploadReq);
  }
}
